import type { FaireProductEntity } from "../../entity_types/product";

export const p_jhr8yxhz9n: FaireProductEntity = {
  token: "p_jhr8yxhz9n",
  type: "product",
  name: "Unisex Terry Long Sleeves: Retro Modern Streetwear Design",
  brandToken: "b_fj2hyk2c4h",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e325c707cc1c4ca864667314020fa52c31f724a1959dfc28672d58cb1f1b797c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15fbd04d2eea850bfa1e97152858b3b3c375228838238e7daf9e3a39f9f55717.jpeg",
    "https://cdn.faire.com/fastly/04916d5c700e8721979d06adfc9ceddd08927bbe376d32174c6c547ba7369bfe.jpeg",
    "https://cdn.faire.com/fastly/958f7a02e1ff1d6d4f0ba3640a97eb3534d81ef9b1c13ffebed15b2384785fe1.jpeg",
    "https://cdn.faire.com/fastly/daa284731d765bae68823d39ec653791dc5b7ef158103d1dbe2e8aff7547d61c.png",
    "https://cdn.faire.com/fastly/fc8b284e928e2f76a414a4dec335396beb8333551b4b0c6d2843dff8786c8006.jpeg",
    "https://cdn.faire.com/fastly/98862d5a993bf0a5251980d472f0b4596e94d72669ec0ec268473e98c4bd162f.jpeg",
    "https://cdn.faire.com/fastly/2593bbe910095119b4138918acedcda7b57dfd20cf71333fa732e91feb1f7d3f.jpeg",
    "https://cdn.faire.com/fastly/275fc0ddf717c2795632dbfb6d8b33c5f48384c314b45f172605920013e97c41.jpeg",
    "https://cdn.faire.com/fastly/80e66a623b4d624dd9dfa9756a8efb841b02a0517cd680d8d1f7ae97752ade9f.jpeg",
    "https://cdn.faire.com/fastly/2a919f2d3f75a80712e95348a3692888b3db60d72ccee096d3491f70aad1cb3b.jpeg",
    "https://cdn.faire.com/fastly/adf7ebb881b144a9ce2341c12228560585c756aeff91cbe2b2172b7d4149735c.jpeg",
    "https://cdn.faire.com/fastly/8e6cc649f99e62f38e6db04ca5c2724805617e81e2d1c0c845124efc2bef08a2.jpeg",
    "https://cdn.faire.com/fastly/ace2400975cd7822ecc6c422f320ad00f709881111ceb2690268d71a87b44245.jpeg",
    "https://cdn.faire.com/fastly/4b545fa25dd04eebe9016abd52a6557c77a5d0550a3a110967eab9e7888a4178.jpeg",
    "https://cdn.faire.com/fastly/d684d5070eba11fd2cb5aa5696e7da6591b5b16bb267ecd6d8bef87e51cb319d.jpeg",
    "https://cdn.faire.com/fastly/14fff721e3d7843df08b75d269bfe7cb71a9bf24b7502f3a3fb667fb6a3ecc05.jpeg",
    "https://cdn.faire.com/fastly/81f31e3c211f33dd7822c22d36a1e9995a5467737b6aec92394a0c136b3cbe1f.jpeg",
    "https://cdn.faire.com/fastly/a6eaec3092bbd30eae7acde5a09b23b5242fad4609c8b960f2ad9f9e61003f61.jpeg",
    "https://cdn.faire.com/fastly/c3a0f6f6a6eed6e9d9e7e42409d571b61c0e938ff7310a6aac55e30f49a5092a.jpeg",
    "https://cdn.faire.com/fastly/d274e2fd6878d9d209cffc8e1e9619db376fa14d53afd0a638eb88066713e2d0.jpeg",
    "https://cdn.faire.com/fastly/dd7ab4a6299ec6606077d4cb1ad152f5b1b3a1b1049a4900c578662dacff4212.jpeg",
    "https://cdn.faire.com/fastly/772d75bc9ed29e0347415dcd70c7e119421ac89abd802d464299522016df9fa3.jpeg",
    "https://cdn.faire.com/fastly/028d08f99c276a81d1691ec4c37983ffdef2f58cf8cbd03a2d6599ffaedbc07d.jpeg",
    "https://cdn.faire.com/fastly/3784bfe7e2cebd343cc3eb1bdba1b25f2d3bf7989ac9f9be3be5f38599889210.jpeg",
  ],
  priceDollars: 21.62,
  description:
    "Sleeve Length: Long Sleeve\nLength: Regular\nFabric: Terry Fabric\nMaterial: Knitted Fabric\nComposition: 58% Cotton, 42% Polyester\nWeight: 430g\nDetails:\nUnisex design suitable for both men and women\nRetro and innovative combination of modern and retro design\nRound neck collar with comfortable streetwear fit\nCare Instructions: Machine Wash Cold, Do Not Dry Clean, Do Not Bleach, Hang Dry, Do Not Iron\nThe clothes are made of high quality fabric, it will not be very transparent, no embarrassing lines.",
  tags: [],
  msrpDollars: 43.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:54.244Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
